export default __webpack_public_path__ + "./images/vg.06ef8bf0.png";